module.exports = __webpack_public_path__ + "./fonts/04c8ef7df821897ba88382c0d0319bab.woff";